import { useEffect, useMemo, useState } from 'react';
import { managerApi } from '../../lib/api';
import { waLink } from '../../lib/whatsapp';
import { errorMessage } from '../../components/ErrorModalBody';

type Canal = 'push' | 'whatsapp' | 'ambos';

export function RemindersTab() {
  const [pendentes, setPendentes] = useState<any[]>([]);
  const [camarotes, setCamarotes] = useState<string[]>([]);
  const [camarote, setCamarote] = useState('todos');
  const [selected, setSelected] = useState<Set<string>>(new Set());
  const [loading, setLoading] = useState(true);
  const [sending, setSending] = useState(false);
  const [results, setResults] = useState<any[]>([]);
  const [waList, setWaList] = useState<{ nome: string; link: string }[]>([]);

  async function reload() {
    const [rem, cfg] = await Promise.all([
      managerApi.listPendingReminders(camarote === 'todos' ? undefined : camarote),
      managerApi.getConfig(),
    ]);
    setPendentes(rem.pendentes);
    setCamarotes(cfg.config.camarotes);
    setSelected(new Set(rem.pendentes.map((p: any) => p.id)));
    setResults([]);
    setWaList([]);
  }
  useEffect(() => { setLoading(true); reload().finally(() => setLoading(false)); }, [camarote]);

  function toggle(id: string) {
    setSelected((prev) => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id); else next.add(id);
      return next;
    });
  }
  function toggleAll() {
    setSelected((prev) => prev.size === pendentes.length ? new Set() : new Set(pendentes.map((p) => p.id)));
  }

  const selecionados = useMemo(() => pendentes.filter((p) => selected.has(p.id)), [pendentes, selected]);

  async function enviar(canal: Canal) {
    if (selecionados.length === 0) { alert('Selecione ao menos um funcionário.'); return; }
    setSending(true);
    setResults([]);
    setWaList([]);
    try {
      if (canal === 'push' || canal === 'ambos') {
        const res = await managerApi.sendPushReminder(selecionados.map((p) => p.id));
        setResults(res.results);
      }
      if (canal === 'whatsapp' || canal === 'ambos') {
        const list = selecionados.filter((p) => p.telefone).map((p) => ({ nome: p.nome, link: waLink(p.telefone, p.mensagemSugerida) }));
        setWaList(list);
      }
    } catch (err) {
      alert(errorMessage(err));
    } finally {
      setSending(false);
    }
  }

  if (loading) return <div className="card"><p className="muted">Carregando…</p></div>;

  return (
    <>
      <div className="card">
        <div className="toolbar">
          <h2 style={{ margin: 0 }}>Lembretes de hoje</h2>
          <button className="btn btn-ghost btn-sm" onClick={reload}>Atualizar</button>
        </div>
        <p className="hint">Varredura de quem ainda não bateu ponto, não registrou vale-alimentação ou não confirmou os recebimentos únicos de hoje.</p>
        <label>Camarote</label>
        <select value={camarote} onChange={(e) => setCamarote(e.target.value)}>
          <option value="todos">Todos os camarotes</option>
          {camarotes.map((c) => <option key={c} value={c}>{c}</option>)}
        </select>
      </div>

      {pendentes.length === 0 && <div className="card"><p className="hint">Ninguém pendente no momento. 🎉</p></div>}

      {pendentes.length > 0 && (
        <div className="card">
          <div className="toolbar">
            <button className="btn btn-ghost btn-sm" onClick={toggleAll}>{selected.size === pendentes.length ? 'Desmarcar todos' : 'Selecionar todos'}</button>
            <span className="muted">{selected.size} selecionado(s)</span>
          </div>
          <div className="row" style={{ marginTop: 10 }}>
            <button className="btn btn-primary btn-sm" style={{ flex: 1 }} disabled={sending} onClick={() => enviar('push')}>Enviar por Notificação</button>
            <button className="btn btn-teal btn-sm" style={{ flex: 1 }} disabled={sending} onClick={() => enviar('whatsapp')}>Enviar por WhatsApp</button>
            <button className="btn btn-gold btn-sm" style={{ flex: 1 }} disabled={sending} onClick={() => enviar('ambos')}>Notificação + WhatsApp</button>
          </div>
        </div>
      )}

      {waList.length > 0 && (
        <div className="card">
          <h2>Links do WhatsApp</h2>
          <p className="hint">Clique em cada botão — abre o WhatsApp Web/app com a mensagem já escrita, só confirmar o envio.</p>
          {waList.map((w) => (
            <a key={w.nome} className="btn btn-teal btn-block" style={{ marginBottom: 8, textDecoration: 'none' }} href={w.link} target="_blank" rel="noreferrer">Enviar para {w.nome}</a>
          ))}
        </div>
      )}

      {pendentes.map((p) => {
        const resultado = results.find((r) => r.id === p.id);
        return (
          <div className="card" style={{ padding: '14px 16px', marginBottom: 10 }} key={p.id}>
            <label className="checkrow" style={{ marginTop: 0, alignItems: 'flex-start' }}>
              <input type="checkbox" checked={selected.has(p.id)} onChange={() => toggle(p.id)} />
              <div>
                <div style={{ fontWeight: 700 }}>{p.nome} {!p.telefone && <span className="pill pill-off">sem telefone</span>}</div>
                <div className="muted" style={{ marginTop: 4 }}>
                  {p.pontoFaltando.length > 0 && <div>Ponto pendente: {p.pontoFaltando.join(', ')}</div>}
                  {p.alimFaltando && <div>Vale-alimentação de hoje pendente</div>}
                  {p.recvFaltando.length > 0 && <div>Recebimentos pendentes: {p.recvFaltando.join(', ')}</div>}
                </div>
                {resultado && (
                  <div className={`pill ${resultado.sucesso ? 'pill-ok' : 'pill-pending'}`} style={{ marginTop: 8 }}>
                    {resultado.sucesso ? '✓ notificação enviada' : resultado.detalhe}
                  </div>
                )}
              </div>
            </label>
          </div>
        );
      })}
    </>
  );
}
